import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {ChooseCardComponent} from "./components/ChooseCardComponent";
import {PayWithAddedCardComponent} from "./components/PayWithAddedCardComponent";
import {PaymentMethodAcceptOrChange} from "./components/PaymentMethodAcceptOrChange.jsx";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {CARD_SECTION_STATE} from "../../../flows/PaymentMethodController.js";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {iFrameState} from "../../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";
import {Controller} from "../../../flows/Controller.js";
import {Toast} from "../../../../ui/Toast.jsx";


// TODO @mustfix WTF
const CARD_SECTION_MAP = {
    [CARD_SECTION_STATE.chooseCard]: ChooseCardComponent,
    [CARD_SECTION_STATE.payWithAddedCard]: PayWithAddedCardComponent,
    [CARD_SECTION_STATE.usingCard]: PaymentMethodAcceptOrChange,
    [CARD_SECTION_STATE.addCard]: PayWithAddedCardComponent,
};

export class PaymentMethodPanel extends BasePanelPage {
    getCardSectionState() {
        if ((!Controller.paymentMethod.initialPaymentMethod && !iFrameUserDataService.getExtraPaymentMethodCount())
            || iFrameMerchantService.isCDSPaymentMethod()) {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.payWithAddedCard;
        }
        return Controller.paymentMethod.cardSectionState;
    }

    render() {
        const {styleSheet} = this;

        Controller.paymentMethod.autoselectPaymentMethod();

        // TODO @cleanup dumb ass
        const CardSectionClass = CARD_SECTION_MAP[this.getCardSectionState()];
        const onAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.addCard;
            Router.updateURL();
        };

        return [
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <CardSectionClass
                ref="cardComponent"
                paymentMethod={Controller.paymentMethod.selectedPaymentMethod}
                className={this.styleSheet.cardComponent}
                hideActiveCard={true}
                onChange={() => this.redraw()}
                onAddCard={onAddCard}
                entry={Controller.paymentMethod.entry}
            />,
            this.renderButtonSection(),
        ];
    }

    isButtonDisabled() {
        return !(this.cardComponent?.isValid());
    }

    renderButtonSection() {
        const {styleSheet} = this;

        const cancelAddCard = () => {
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
        };
        const giftSubscriptionMessage = iFrameState.panelType === PANEL_TYPE.giftSubscription ?
            <div>{Messages.giftPaymentMethodDescription}</div> : "";

        if (this.getCardSectionState() === CARD_SECTION_STATE.chooseCard ||
            this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard) {
            return [
                giftSubscriptionMessage, // WTF, what?
                <MerchantButton
                    ref="button"
                    className={styleSheet.actionButton}
                    disabled={this.isButtonDisabled()}
                    label={this.getCardSectionState() === CARD_SECTION_STATE.payWithAddedCard ?
                        Controller.paymentMethod.getPayWithAddedCardButtonLabel() :
                        Controller.paymentMethod.getChooseCardButtonLabel()}
                    onClick={() => this.continueWithChosenCard()}
                />,

                <div className={styleSheet.backButton} onClick={() => Controller.paymentMethod.onSelectCancel()}>
                    {Messages.back}
                </div>
            ];
        }

        return [
            giftSubscriptionMessage,
            <MerchantButton
                ref="button"
                className={styleSheet.actionButton}
                disabled={this.isButtonDisabled()}
                label={Messages.continue}
                onClick={() => this.addCard()}
            />,
            <div onClick={cancelAddCard} className={styleSheet.backButton}>
                {Messages.cancel}
            </div>
        ];
    }

    continueWithChosenCard() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), preferredPaymentMethodId => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                Controller.paymentMethod.selectedPaymentMethod = preferredPaymentMethodId;
            } else {
                Controller.paymentMethod.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            }

            Controller.paymentMethod.onSelectSuccess();
        }, error => {
            if (Controller.paymentMethod.cardSectionState === CARD_SECTION_STATE.chooseCard) {
                Toast.showError(error);
            }
            LoadingSpinner.hide();
        });
    }

    addCard() {
        LoadingSpinner.show();
        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), preferredPaymentMethodId => {
            Controller.paymentMethod.selectedPaymentMethod = PaymentMethodStore.get(preferredPaymentMethodId);
            Controller.paymentMethod.cardSectionState = CARD_SECTION_STATE.chooseCard;
            Router.updateURL();
            LoadingSpinner.hide();
        }, () => LoadingSpinner.hide());
    }

    onMount() {
        super.onMount();
        this.redraw(); // TODO @input needed for the button to not be disabled

        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
